module.exports = __webpack_public_path__ + "static/media/Rosewood Drive, San Francisco, CA1.4fda014f.jpg";